import { Box, Theme, Typography } from "@outschool/backpack";
import { DEFAULT_40_DOLLARS_OFF_COUPON_CODE } from "@outschool/business-rules";
import { Trans, useTranslation } from "@outschool/localization";
import { joinMembershipPath } from "@outschool/routes";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useIsMobile, useNavigation } from "@outschool/ui-utils";
import React, { useEffect } from "react";

export default function FirstMonthFreeBanner() {
  const { t } = useTranslation(
    "client\\components\\banners\\FirstMonthFreeBanner",
  );
  const navigate = useNavigation();
  const trackEvent = useTrackEvent();
  const isMobile = useIsMobile();

  // Track if banner view has been tracked for this mount to prevent duplicate tracking
  const hasTrackedViewRef = React.useRef<boolean>(false);

  useEffect(() => {
    if (!hasTrackedViewRef.current) {
      hasTrackedViewRef.current = true;
      trackEvent("first_month_free_banner_view", {
        is_mobile: isMobile,
      });
    }
  }, [trackEvent, isMobile]);

  const handleBannerClick = () => {
    trackEvent("first_month_free_banner_click", {
      is_mobile: isMobile,
    });
    navigate(joinMembershipPath());
  };

  const PromoBanner = () => {
    return (
      <>
        <Typography component="span">
          🌱&nbsp;
          <Trans t={t}>Get ready for spring with a free trial. Use code</Trans>
          &nbsp;
        </Typography>
        <Typography
          sx={{
            textDecoration: "underline",
          }}
        >
          {DEFAULT_40_DOLLARS_OFF_COUPON_CODE}
        </Typography>
        .
        <Typography
          sx={(theme: Theme) => ({
            [theme.breakpoints.down("md")]: {
              display: "none",
            },
          })}
        >
          &nbsp;
          <Trans t={t}>Limited time.</Trans>
        </Typography>
      </>
    );
  };

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary[600],
        minHeight: "50px",
        cursor: "pointer",
        padding: "0 1em",
      })}
      onClick={handleBannerClick}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "1440px",
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography variant="body1" sx={{ textAlign: "center" }}>
              <PromoBanner />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
